import configState from './config-state'
import configGetters from './config-getters'
import configMutation from './config-mutation'

export default {
	namespaced: true,
	state: configState,
	getters: configGetters,
	mutations: configMutation
}
